import { SuggestionItem, SuggestionType } from "@/types/suggestions";

import { requestData } from "@/api/api-config";

export async function createSuggestion(
  suggestion: SuggestionItem,
): Promise<SuggestionItem | null> {
  return await requestData<SuggestionItem>(
    "suggestions",
    "post",
    {
      json: suggestion,
    },
    false,
  );
}

export async function updateSuggestion(
  suggestion: SuggestionItem,
): Promise<SuggestionItem | null> {
  return await requestData<SuggestionItem>(
    "suggestions",
    "put",
    { json: suggestion },
    false,
  );
}

export async function deleteSuggestion(
  suggestion: SuggestionItem,
): Promise<SuggestionItem | null> {
  return await requestData<SuggestionItem>(
    "suggestions",
    "delete",
    { json: suggestion },
    false,
  );
}

export async function reorderSuggestions(
  ids: string[],
): Promise<boolean | null> {
  return await requestData<boolean>(
    "suggestions/reorder",
    "put",
    { json: { ids } },
    false,
  );
}

export interface PersonalSuggestionCreate {
  label: string;
  content: string;
  preview?: string | null;
}

// The backend requires id on update (400 without it); keep it required here so misuse
// is a compile error, not a runtime 400.
export interface PersonalSuggestionUpdate extends PersonalSuggestionCreate {
  id: string;
}

export async function fetchPersonalSuggestions(): Promise<
  SuggestionItem[] | null
> {
  return await requestData<SuggestionItem[]>(
    "suggestions/personal",
    "get",
    {},
    false,
  );
}

export async function createPersonalSuggestion(
  suggestion: PersonalSuggestionCreate,
): Promise<SuggestionItem | null> {
  return await requestData<SuggestionItem>(
    "suggestions/personal",
    "post",
    { json: suggestion },
    false,
  );
}

export async function updatePersonalSuggestion(
  suggestion: PersonalSuggestionUpdate,
): Promise<SuggestionItem | null> {
  return await requestData<SuggestionItem>(
    "suggestions/personal",
    "put",
    { json: suggestion },
    false,
  );
}

export async function deletePersonalSuggestion(
  suggestionId: string,
): Promise<SuggestionItem | null> {
  return await requestData<SuggestionItem>(
    `suggestions/personal/${suggestionId}`,
    "delete",
    {},
    false,
  );
}

export async function fetchSuggestions(
  suggestionTypes: SuggestionType[],
  patientId?: string,
  eventId?: string,
  scope?: {
    providerId?: string;
    noteTemplateId?: string;
    noteQuestionId?: string;
  },
): Promise<SuggestionItem[] | null> {
  return await requestData<SuggestionItem[]>(
    "suggestions",
    "get",
    {
      searchParams: {
        patientId,
        suggestionTypes,
        eventId,
        providerId: scope?.providerId,
        noteTemplateId: scope?.noteTemplateId,
        noteQuestionId: scope?.noteQuestionId,
      },
    },
    false,
  );
}
